export default __webpack_public_path__ + "static/media/kat_single.cc1975e7.pdf";